/**
 * CONFIGURACIÓN DEL MENÚ LATERAL
 * ================================
 * Para modificar el menú edita este archivo:
 *
 * - Agregar ítem:    añade un objeto al array NAV_ITEMS (con su `perm`)
 * - Eliminar ítem:   borra el objeto correspondiente
 * - Cambiar título:  edita el campo `title`
 * - Cambiar ícono:   importa otro ícono MUI y reemplaza en `icon`
 * - Cambiar ruta:    edita el campo `path`
 * - Mover al fondo:  mueve el objeto a BOTTOM_NAV_ITEMS
 *
 * Íconos disponibles: https://mui.com/material-ui/material-icons/
 */

// ─── Íconos principales ───────────────────────────────────────────────────────
import NaturePeopleIcon  from '@mui/icons-material/NaturePeople';   // Campamentos
import GroupsIcon        from '@mui/icons-material/Groups';           // Clubes
import PeopleIcon        from '@mui/icons-material/People';           // Usuarios
import BadgeIcon         from '@mui/icons-material/Badge';            // Directores
import EventIcon         from '@mui/icons-material/Event';            // Eventos
import CategoryIcon      from '@mui/icons-material/Category';         // Tipos de Evento
import RuleIcon          from '@mui/icons-material/Rule';             // Rúbricas
import GavelIcon         from '@mui/icons-material/Gavel';            // Jueces
import AssessmentIcon    from '@mui/icons-material/Assessment';       // Reportes

// ─── Íconos secundarios (pie de sidebar) ─────────────────────────────────────
import SettingsIcon     from '@mui/icons-material/Settings';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';  // Observabilidad

// =============================================================================
// ÍTEMS PRINCIPALES — aparecen en el centro del sidebar
// =============================================================================
export const NAV_ITEMS = [
  {
    title: 'Campamentos',
    path: '/campamento',
    icon: NaturePeopleIcon,
    perm: 'camps.manage',
  },
  {
    title: 'Clubes',
    path: '/clubes',
    icon: GroupsIcon,
    perm: 'clubs.view',
  },
  {
    title: 'Usuarios',
    path: '/user',
    icon: PeopleIcon,
    perm: 'users.view',
  },
  {
    title: 'Directores',
    path: '/directors',
    icon: BadgeIcon,
    perm: 'directors.view',
  },
  {
    title: 'Eventos',
    path: '/events',
    icon: EventIcon,
    perm: 'events.manage',
  },
  // {
  //   title: 'Tipos de Evento',
  //   path: '/event_type',
  //   icon: CategoryIcon,
  // },
  // },
  // {
  //   title: 'Rúbricas',
  //   path: '/rubric',
  //   icon: RuleIcon,
  // },
  // {
  //   title: 'Jueces',
  //   path: '/judge',
  //   icon: GavelIcon,
  // },
  {
    title: 'Reportes',
    path: '/reports',
    icon: AssessmentIcon,
    perm: 'reports.view',
  },
  {
    title: 'Watchtower',
    path: '/watchtower',
    icon: MonitorHeartIcon,
    // Por defecto solo el super-admin. Un admin concreto puede recibirlo con un
    // override `grant: ['watchtower.view']`; el backend exige el mismo permiso.
    perm: 'watchtower.view',
  },
];

// =============================================================================
// ÍTEMS INFERIORES — aparecen al fondo del sidebar (sobre el perfil de usuario)
// =============================================================================
// Se filtran por `perm` igual que NAV_ITEMS: antes se renderizaban sin filtro,
// así que "Configuración" era visible para cualquier usuario autenticado.
export const BOTTOM_NAV_ITEMS = [
  {
    title: 'Configuración',
    path: '/settings',
    icon: SettingsIcon,
    perm: 'affiliations.manage',
  },
];
